// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InsightPollController from "./insight_poll_controller"
application.register("insight-poll", InsightPollController)

import MessageFormController from "./message_form_controller"
application.register("message-form", MessageFormController)

import PublicNavController from "./public_nav_controller"
application.register("public-nav", PublicNavController)

import AutoscrollController from "./autoscroll_controller"
application.register("autoscroll", AutoscrollController)

import AutoresizeController from "./autoresize_controller"
application.register("autoresize", AutoresizeController)

import ChipController from "./chip_controller"
application.register("chip", ChipController)

import SaveReadingController from "./save_reading_controller"
application.register("save-reading", SaveReadingController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import PanelDrawerController from "./panel_drawer_controller"
application.register("panel-drawer", PanelDrawerController)

import MobileMoreController from "./mobile_more_controller"
application.register("mobile-more", MobileMoreController)

import AnalyticsConsentController from "./analytics_consent_controller"
application.register("analytics-consent", AnalyticsConsentController)

import AnalyticsTrackerController from "./analytics_tracker_controller"
application.register("analytics-tracker", AnalyticsTrackerController)

import MessageResyncController from "./message_resync_controller"
application.register("message-resync", MessageResyncController)
